<template>

  <collapse-card open :loading="loading">
    <div slot="title">Зоны внимания</div>
    <div slot="link">
      <div  v-if="isNewFormat || editable" @click.stop="editEditable(); update()" class="edit-link">Сохранить</div>
      <div v-else @click.stop="editEditable();" class="edit-link">Редактировать</div>
    </div>

    <attention-zones-list v-if="isNewFormat" :data-table="conclusion.attention_zones"/>
    <div v-else class="content">
      <div v-if="conclusion" class="content__text">

        <el-input v-if="editable"
                  ref="attention_zones"
                  v-model="conclusion.attention_zones"
                  type="textarea"
                  autosize
                  class="content__text_input"/>
        <template v-else>{{ conclusion.attention_zones | empty }}</template>

      </div>
      <div class="content__edit">

      </div>
    </div>

  </collapse-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import CollapseCard from "@/components/elements/BigCard.vue"
import AttentionZonesList from "@/components/AttentionZonesList/List.vue"

export default {
  name: "AttentionZones",
  components: {
    CollapseCard,
    AttentionZonesList
  },
  data() {
    return {
      loading: false,
      editable: false,
      editIndex: 0,
      dataTable: [
        {
          id: 1,
          icon: '',
          title: 'Нервная система',
          organ: 'Желудок, тонкий кишечник',
        },
        {
          id: 2,
          icon: '',
          title: 'Пищеварительная система',
          organ: 'Шейный отдел позвоночника, старая травма коленного сустава\n',
        }
      ],
      types: [
        {
          id: 1,
          value: 'Пищеварительная система'
        },
        {
          id: 2,
          value: 'Дыхательная система'
        }
      ]
    }
  },
  computed: {
    ...mapGetters("visit", {
          conclusion: "conclusion"
        },
    ),
    visitId() {
      return this.$route.params.id;
    },
    isNewFormat () {
      return Array.isArray(this.conclusion.attention_zones)
    }
  },
  filters: {
    empty(value) {
      return value === '' ? 'Данные остутствуют' : value
    }
  },
  methods: {
    ...mapActions({
      updateConclusion: "visit/UPDATE_CONCLUSION",
    }),
    save() {
      this.editable = false
      this.$emit('update')
    },
    editEditable() {
      this.editable = !this.editable
      this.$nextTick(() => {
        if (this.$refs.attention_zones) this.$refs.attention_zones.focus()
      })
    },
    update() {

      this.loading = true
      this.updateConclusion(this.conclusion).then(() => {
        this.$notify.success({
          title: "Успешно",
          message: "Данные обновлены",
        })
      }).catch((response) => {
        this.$notify.error({
          title: "Ошибка 😕",
          message: response.response.data.message
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/scss/zebra-table.scss";

.edit-link {
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
  line-height: 26px;

  color: #43D3B3;

  &:hover {
    opacity: .5;
  }
}

.title {
  margin: 16px 0 8px 0;
  font-size: 15px;
  line-height: 20px;


  color: #8E8E93;
}

.subtitle {
  margin-top: 12px;

  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  color: #111;

}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__text {
    flex: 1;
    padding-right: 30px;

    font-size: 13px;
    line-height: 16px;

    letter-spacing: -0.005em;
    color: #111111;
  }

  &__edit {
    width: 30px;
    color: #8E8E93;
    cursor: pointer;

    &:hover {
      opacity: 0.5
    }
  }
}

.content__text {
  white-space: pre-wrap;

  &_input {
    /deep/ input {
      width: 100%;
    }
  }
}
</style>